<app-top-nav  class="mat-elevation-z6"></app-top-nav>
<router-outlet [class.has-tabs]="hasTabs"></router-outlet>
<app-toasts></app-toasts>
<ui-draft-overlay></ui-draft-overlay>
<app-lock *ngIf="isLocked" (login)="startIdleTimer()" (logout)="logout()"></app-lock>
